import { mods } from '@approvalmax/theme';
import { Field } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const StyledCustomField = styled(Field)<StyledMods<{ hasMargins: boolean }>>`
    width: 267px;
    min-width: 267px;

    ${mods('hasMargins', true)`
        margin-bottom: 22px;
        margin-right: 30px;
    `}
`;
